<template>
  <div>
    <ul class="nav nav-tabs">
      <li class="nav-item" v-if="checkClaim(CAN_VIEW_PARTS)">
        <router-link :to="partsLink" class="nav-link">
          <i class="fa fa-cube mr-1"/>Parts
        </router-link>
      </li>
      <li class="nav-item" v-if="checkClaim(CAN_VIEW_INVENTORY)">
        <router-link :to="inventoryLink" class="nav-link">
          <i class="fa fa-cubes mr-1"/>Inventory
        </router-link>
      </li>
      <li class="nav-item" v-if="checkClaim(CAN_VIEW_INVENTORY)">
        <router-link :to="ncmReportLink" class="nav-link">
          <i class="fa fa-file mr-1"/>NCM
        </router-link>
      </li>
      <li class="nav-item" v-if="checkClaim(CAN_VIEW_INVENTORY)">
        <router-link :to="inspectionReportLink" class="nav-link">
          <i class="fa fa-sticky-note-o mr-1"/>Inspection Reports
        </router-link>
      </li>
    </ul>
    <router-view></router-view>
  </div>
</template>
<script>
  import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';

  export default {
    metaInfo: () => ({
      title: 'New Erp',
    }),
    data() {
      return {};
    },
    computed: {
      ...mapGetters('partsCenter', ['lastOpenedTab',
        'partsLink',
        'inventoryLink',
        'ncmReportLink',
        'inspectionReportLink'
      ]),
    },
    methods: {
      ...mapMutations('partsCenter', ['setItem']),
    },
    watch: {},
    mounted() {
      console.log(this.partsLink, "Parts Link")
      if (!this.lastOpenedTab) {
        this.setItem({ resource: 'partsLink', payload: this.partsLink });
        this.setItem({ resource: 'lastOpenedTab', payload: this.partsLink });
      }
      if (this.$route.meta.controlLink) {
        this.setItem({ resource: this.$route.meta.controlLink, payload: this.$route.fullPath });
        this.setItem({ resource: 'lastOpenedTab', payload: this.$route.fullPath });
      }
    },
  };
</script>

<style scoped>
.new-offer-button {
  right: 10px;
  position: absolute;
  top: 4px;
}
</style>
